import * as React from 'react';
import { Res } from 'core/api';
import { Flex, Format } from 'core/ui';

export default function AmountControl({ amount }: { amount: number; }): React.ReactNode {
	return <Flex.Vertical>
		<Flex.Item style={{ backgroundColor: '#000000' }} size='60px'>
			<h3 className='m-l-sm  text-center' style={{ color: '#FFFFFF' }}>
				{Res.Web.SCREEN_DISPLAY_TOTAL_CONTROL_LBL()}
			</h3>
		</Flex.Item>
		<Flex.Item className='m-l-xl m-r-xl' size='*'>
			<div>
				<h1 className='font-bold m-l-lg'>
					{Res.Web.SCREEN_DISPLAY_TOTAL_CONTROL_NET_AMOUNT_LBL()}
				</h1>
			</div>
			<div className='font-extra-bold pull-right m-r-xl' style={{ fontSize: '4.5em', color: 'black' }}>
				{Format.asMoney(amount)}
			</div>

		</Flex.Item>
		<Flex.Item style={{ backgroundColor: '#000000' }} size='60px'> </Flex.Item>
	</Flex.Vertical>;
}
